export default {
    AUTH: 'auth',
    CART: 'cart',
    MAIN: 'main',
    MESSAGES: 'messages',
    MONERIS: 'moneris',
    SHOP: 'shop',
    TOAST: 'toast'
}
